import { RedoOutlined, SearchOutlined } from "@ant-design/icons"
import { Button, Card, ConfigProvider, Form, Input, Select, Space } from "antd"
import type React from "react"
import { memo, useEffect } from "react"
import type { HeadwordSearchParams } from "@/services/dictionary/headwordApi"

interface HeadwordSearchFormProps {
  onSearch: (values: Omit<HeadwordSearchParams, "page" | "per_page">) => void
  loading?: boolean
  initialValues?: Omit<HeadwordSearchParams, "page" | "per_page">
}

export const HEAD_WORD_STATUS = {
  INIT: 0,
  DRAFT: 1,
  PUBLISHED: 10,
  REJECTED: -1,
}

const STATUS_OPTIONS = [
  { value: HEAD_WORD_STATUS.INIT, label: "Khởi tạo (INIT)" },
  { value: HEAD_WORD_STATUS.DRAFT, label: "Bản nháp (DRAFT)" },
  { value: HEAD_WORD_STATUS.PUBLISHED, label: "Đã xuất bản (PUBLISHED)" },
  { value: HEAD_WORD_STATUS.REJECTED, label: "Bị từ chối (REJECTED)" },
]

const HeadwordSearchForm: React.FC<HeadwordSearchFormProps> = memo(({ onSearch, loading = false, initialValues }) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues)
    }
  }, [initialValues, form])

  const handleSearch = () => {
    form.validateFields().then((values) => {
      onSearch(values)
    })
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({
      search: "",
      status: HEAD_WORD_STATUS.PUBLISHED,
    })
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
          },
        },
      }}
    >
      <Card>
        <Form
          form={form}
          initialValues={{
            search: "",
            status: HEAD_WORD_STATUS.PUBLISHED,
          }}
          className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3"
        >
          <Form.Item name="search" label="Từ gốc" colon={false} className="mb-0">
            <Input allowClear autoComplete="off" placeholder="Tìm kiếm từ vựng..." onPressEnter={handleSearch} />
          </Form.Item>
          <Form.Item name="status" label="Trạng thái" colon={false} className="mb-0">
            <Select allowClear placeholder="Chọn trạng thái" options={STATUS_OPTIONS} onChange={handleSearch} />
          </Form.Item>

          <Form.Item label=" " colon={false} className="mb-0">
            <Space>
              <Button type="default" icon={<RedoOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </ConfigProvider>
  )
})

HeadwordSearchForm.displayName = "HeadwordSearchForm"

export default HeadwordSearchForm
